import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-identification-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent {
  @Input()
  data: any;

  @Input()
  searchResultType!: number;

  @Output()
  doResetSearch = new EventEmitter<any>();

  constructor() {}

  resetSearch() {
    this.doResetSearch.emit(true);
  }
}
